/* AmeOro contact page: Client Services status + the stitched distribution network map. */
(() => {
  // Country label points [lon, lat] (mainland centroid, world-atlas countries-50m). Generated; do not hand-edit.
  const CENTROIDS = {"ZW":[29.9,-19],"ZM":[27.8,-13.5],"YE":[47.5,15.9],"VN":[106.3,16.5],"VE":[-66.2,7.1],"VA":[12.4,41.9],"VU":[166.8,-15.2],"UZ":[63.3,41.8],"UY":[-56,-32.8],"FM":[158.2,6.9],"MH":[171.2,7.1],"MP":[145.7,15.2],"VI":[-64.8,17.7],"GU":[144.8,13.4],"AS":[-170.7,-14.3],"PR":[-66.5,18.2],"US":[-98.8,39.9],"GS":[-36.7,-54.4],"IO":[72.4,-7.3],"SH":[-5.7,-16],"PN":[-128.3,-24.4],"AI":[-63.1,18.2],"FK":[-58.8,-51.7],"KY":[-81.3,19.3],"BM":[-64.8,32.3],"VG":[-64.6,18.4],"TC":[-71.7,21.8],"MS":[-62.2,16.7],"JE":[-2.1,49.2],"GG":[-2.6,49.5],"IM":[-4.5,54.2],"GB":[-2.4,53.8],"AE":[54.3,23.9],"UA":[31.3,49.2],"UG":[32.4,1.3],"TM":[59.4,39.1],"TR":[35.4,39.1],"TN":[9.6,34.1],"TT":[-61.3,10.4],"TO":[-175.2,-21.2],"TG":[1,8.5],"TL":[125.9,-8.8],"TH":[101,15.1],"TZ":[34.8,-6.3],"TJ":[71,38.5],"TW":[121,23.7],"SY":[38.5,35],"CH":[8.2,46.8],"SE":[16.2,62.4],"SZ":[31.5,-26.6],"SR":[-55.9,4.1],"SS":[30.3,7.3],"SD":[29.9,16],"LK":[80.7,7.6],"ES":[-3.6,40.4],"KR":[127.9,36.5],"ZA":[25.2,-29],"SO":[45.7,4.7],"SB":[160.2,-9.6],"SK":[19.5,48.7],"SI":[14.8,46.1],"SG":[103.8,1.4],"SL":[-11.8,8.6],"SC":[55.5,-4.7],"RS":[20.8,44.2],"SN":[-14.5,14.4],"SA":[44.7,24.1],"ST":[6.6,0.2],"SM":[12.5,43.9],"WS":[-172.4,-13.6],"VC":[-61.2,13.3],"LC":[-61,13.9],"KN":[-62.7,17.3],"RW":[29.9,-2],"RU":[95.5,65.9],"RO":[25,45.8],"QA":[51.2,25.3],"PT":[-8,39.7],"PL":[19.4,52.1],"PH":[121.4,15.9],"PE":[-74.4,-9.1],"PY":[-58.4,-23.2],"PG":[144.2,-6.6],"PA":[-80.1,8.5],"PW":[134.6,7.5],"PK":[69.2,29.9],"OM":[56.1,20.6],"NO":[12.2,63.8],"KP":[127.2,40.1],"NG":[8.1,9.6],"NE":[9.3,17.4],"NI":[-85,12.8],"NZ":[170.6,-43.9],"NU":[-169.9,-19],"CK":[-159.8,-21.2],"NL":[5.6,52.3],"AW":[-70,12.5],"CW":[-69,12.2],"NP":[83.9,28.3],"NR":[166.9,-0.5],"NA":[17.2,-22.1],"MZ":[35.6,-17.2],"MA":[-8.7,29.8],"EH":[-12.3,24.2],"ME":[19.2,42.8],"MN":[103.1,47],"MD":[28.5,47.2],"MC":[7.4,43.8],"MX":[-102.2,23.9],"MU":[57.6,-20.3],"MR":[-10.4,20.2],"MT":[14.4,35.9],"ML":[-3.6,17.3],"MV":[73.5,4.2],"MY":[114.7,3.6],"MW":[34.3,-13.2],"MG":[46.7,-19.3],"MK":[21.7,41.6],"LU":[6.1,49.8],"LT":[23.9,55.3],"LI":[9.5,47.1],"LY":[18.1,27],"LR":[-9.3,6.5],"LS":[28.2,-29.6],"LB":[35.9,33.9],"LV":[24.9,56.9],"LA":[103.8,18.5],"KG":[74.5,41.5],"KW":[47.6,29.3],"KI":[-157.4,1.9],"KE":[37.8,0.6],"KZ":[67.2,48.4],"JO":[36.8,31.2],"JP":[137.9,36.6],"JM":[-77.3,18.2],"IT":[12.3,43.5],"IL":[35,31.5],"PS":[35.2,31.9],"IE":[-8.1,53.2],"IQ":[43.8,33],"IR":[54.4,32.5],"ID":[114,-0.2],"IN":[79.5,22.8],"IS":[-18.6,65],"HU":[19.4,47.2],"HN":[-86.6,14.8],"HT":[-72.7,18.9],"GY":[-59,4.8],"GW":[-14.9,12.1],"GN":[-10.9,10.4],"GT":[-90.4,15.7],"GD":[-61.7,12.1],"GR":[22.6,39.5],"GH":[-1.2,7.9],"DE":[10.4,51],"GE":[43.5,42.2],"GM":[-15.4,13.5],"GA":[11.8,-0.6],"FR":[2.5,46.6],"PM":[-56.3,46.9],"WF":[-178.1,-14.3],"MF":[-63.1,18.1],"BL":[-62.8,17.9],"PF":[-149.4,-17.7],"NC":[165.5,-21.3],"TF":[69.5,-49.3],"AX":[19.9,60.2],"FI":[26.2,64.3],"FJ":[178,-17.8],"ET":[39.6,8.6],"EE":[25.8,58.7],"ER":[38.8,15.4],"GQ":[10.5,1.6],"SV":[-88.9,13.7],"EG":[29.9,26.5],"EC":[-78.4,-1.4],"DO":[-70.5,18.9],"DM":[-61.4,15.4],"DJ":[42.6,11.7],"GL":[-41.8,73.1],"FO":[-6.9,62.2],"DK":[9.3,56.2],"CZ":[15.3,49.7],"CY":[33,34.9],"CU":[-78.9,21.6],"HR":[16.4,45.2],"CI":[-5.6,7.6],"CR":[-84.2,10],"CD":[23.6,-2.9],"CG":[15.2,-0.8],"KM":[43.3,-11.7],"CO":[-73.1,3.9],"CN":[103.3,36.8],"MO":[113.5,22.2],"HK":[114.1,22.4],"CL":[-70.9,-34.4],"TD":[18.6,15.3],"CF":[20.5,6.6],"CV":[-23.6,15.1],"CA":[-99,58.6],"CM":[12.7,5.7],"KH":[104.9,12.7],"MM":[96.5,21.1],"BI":[29.9,-3.4],"BF":[-1.8,12.3],"BG":[25.2,42.8],"BN":[114.6,4.5],"BR":[-53.2,-10.7],"BW":[23.8,-22.2],"BA":[17.8,44.2],"BO":[-64.7,-16.7],"BT":[90.4,27.4],"BJ":[2.3,9.6],"BZ":[-88.7,17.2],"BE":[4.6,50.6],"BY":[28,53.5],"BB":[-59.6,13.2],"BD":[90.2,23.9],"BH":[50.5,26],"BS":[-78,24.7],"AZ":[47.7,40.3],"AT":[14.1,47.6],"AU":[123.6,-12.4],"HM":[73.5,-53.1],"NF":[167.9,-29.1],"AM":[44.9,40.3],"AR":[-64.7,-34.5],"AG":[-61.8,17.1],"AO":[17.6,-12.3],"AD":[1.6,42.5],"DZ":[2.6,28.1],"AL":[20.1,41.1],"AF":[65.9,33.8],"AQ":[83,-84.7],"SX":[-63.1,18.1]};
  // ponytail: same EU + CH + NO list as snippets/ameoro-pdp-schema.liquid and the shipping policy.
  const FAST = new Set('AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE CH NO'.split(' '));
  // Europe frame, identical to snippets/ameoro-network-land.liquid.
  const W = 1000;
  const H = 925;
  const project = ([lon, lat]) => [(lon + 11) * 23.80948, (61 - lat) * 35.58277];
  const NS = 'http://www.w3.org/2000/svg';
  const OPEN_HOUR = 9;
  const CLOSE_HOUR = 17;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const svgEl = (tag, attrs, parent) => {
    const node = document.createElementNS(NS, tag);
    for (const key in attrs) node.setAttribute(key, attrs[key]);
    if (parent) parent.appendChild(node);
    return node;
  };
  const ease = (k) => (k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2);
  const curve = (a, b, bow) => {
    const mx = (a.x + b.x) / 2;
    const my = (a.y + b.y) / 2;
    return `M${a.x} ${a.y}Q${mx - (b.y - a.y) * bow} ${my + (b.x - a.x) * bow} ${b.x} ${b.y}`;
  };

  /* ---------- Client Services status ---------- */

  function parisNow(date) {
    const parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Paris', hourCycle: 'h23', weekday: 'short',
      year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'
    }).formatToParts(date).forEach((p) => { parts[p.type] = p.value; });
    const weekday = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(parts.weekday);
    const asUtc = Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour, +parts.minute);
    return { weekday, hour: +parts.hour, y: +parts.year, m: +parts.month - 1, d: +parts.day, offset: asUtc - Math.floor(date.getTime() / 60000) * 60000 };
  }

  function initStatus(root) {
    const status = root.querySelector('[data-contact-status]');
    if (!status) return;
    const text = status.querySelector('[data-contact-status-text]');
    const lang = document.documentElement.lang || 'en';
    const now = new Date();
    const paris = parisNow(now);
    const workday = paris.weekday >= 1 && paris.weekday <= 5;

    if (workday && paris.hour >= OPEN_HOUR && paris.hour < CLOSE_HOUR) {
      status.classList.add('is-online');
      text.textContent = status.dataset.online;
    } else {
      let days = workday && paris.hour < OPEN_HOUR ? 0 : 1;
      while ([0, 6].includes((paris.weekday + days) % 7)) days += 1;
      const opens = new Date(Date.UTC(paris.y, paris.m, paris.d + days, OPEN_HOUR, 0) - paris.offset);
      let label = days === 0
        ? status.dataset.today
        : status.dataset.day.replace('__DAY__', new Intl.DateTimeFormat(lang, { weekday: 'long', timeZone: 'Europe/Paris' }).format(opens));
      if (-now.getTimezoneOffset() * 60000 !== paris.offset) {
        const local = new Intl.DateTimeFormat(lang, { weekday: days === 0 ? undefined : 'short', hour: 'numeric', minute: '2-digit' }).format(opens);
        label += ` (${status.dataset.local.replace('__TIME__', local)})`;
      }
      text.textContent = label;
    }
    status.hidden = false;
  }

  /* ---------- Distribution network ---------- */

  function initNetwork(root) {
    const svg = root.querySelector('[data-net-svg]');
    if (!svg || svg.dataset.ready) return;
    svg.dataset.ready = 'true';

    const threadsG = svg.querySelector('[data-net-threads]');
    const routesG = svg.querySelector('[data-net-routes]');
    const beadsG = svg.querySelector('[data-net-beads]');
    const destG = svg.querySelector('[data-net-dest]');
    const land = svg.querySelector('[data-net-land]');
    const defs = svg.querySelector('defs');
    const select = root.querySelector('[data-net-select]');
    const estimate = root.querySelector('[data-net-estimate]');
    const pauseBtn = root.querySelector('[data-net-pause]');
    const resetBtn = root.querySelector('[data-net-reset]');
    const chips = [...root.querySelectorAll('[data-net-chip]')];
    const panels = [...root.querySelectorAll('[data-net-panel]')];
    const insetSvg = root.querySelector('[data-net-inset] svg');
    const pins = [...svg.querySelectorAll('[data-net-pin]')].map((g) => ({ g, country: g.dataset.country, x: +g.dataset.x, y: +g.dataset.y }));
    if (!pins.length) return;

    let viewBox = [0, 0, W, H];
    let active = null;
    let running = false;
    let paused = false;
    let inView = false;
    let lastFrame = 0;
    let unit = 1;
    const beads = [];
    const steps = [...root.querySelectorAll('[data-net-step]')];
    const delivered = root.querySelector('[data-net-delivered]');
    const replayBtn = root.querySelector('[data-net-replay]');
    let journeyRun = 0;
    let journeyPath = null;
    let parcel = null;

    panels.forEach((p) => { p.hidden = true; });

    const setUnit = () => {
      const px = svg.getBoundingClientRect().width || 1;
      unit = viewBox[2] / px;
      svg.style.setProperty('--u', unit.toFixed(4));
      if (insetSvg) insetSvg.style.setProperty('--u', (300 / (insetSvg.getBoundingClientRect().width || 1)).toFixed(4));
    };
    setUnit();
    new ResizeObserver(setUnit).observe(svg);

    // Stitch every location into one network: minimum spanning tree over the pins.
    const edges = [];
    const joined = [pins[0]];
    const rest = pins.slice(1);
    while (rest.length) {
      let best = null;
      for (const a of joined) for (const b of rest) {
        const d = Math.hypot(a.x - b.x, a.y - b.y);
        if (!best || d < best.d) best = { a, b, d };
      }
      edges.push(best);
      joined.push(best.b);
      rest.splice(rest.indexOf(best.b), 1);
    }

    const addBead = (path, route) => {
      const length = path.getTotalLength();
      if (length < 4 || reduceMotion.matches) return;
      const count = route ? 2 : 1;
      for (let i = 0; i < count; i += 1) {
        beads.push({
          path, length, route,
          t: route ? (length * i) / count : Math.random() * length,
          speed: route ? 55 : 18 + Math.random() * 22,
          el: svgEl('circle', { r: 1, class: `ameoro-net__bead${route ? ' ameoro-net__bead--route' : ''}` }, beadsG)
        });
      }
    };

    // Dashed thread can't be drawn with its own dashoffset, so a solid mask path "sews" it in.
    let maskId = 0;
    const stitch = (path, delay, duration) => {
      if (reduceMotion.matches) return;
      const id = `${svg.id}-stitch-${(maskId += 1)}`;
      const mask = svgEl('mask', { id, maskUnits: 'userSpaceOnUse', x: -100, y: -100, width: W + 200, height: H + 200 }, defs);
      const guide = svgEl('path', { d: path.getAttribute('d'), pathLength: 1, class: 'ameoro-net__stitch-mask' }, mask);
      path.setAttribute('mask', `url(#${id})`);
      guide.animate([{ strokeDashoffset: 1 }, { strokeDashoffset: 0 }], { duration, delay, easing: 'cubic-bezier(.45,0,.25,1)', fill: 'both' })
        .finished.then(() => { path.removeAttribute('mask'); mask.remove(); }).catch(() => {});
    };

    const threadPaths = edges.map((e, i) => {
      const d = curve(e.a, e.b, i % 2 ? 0.16 : -0.16);
      const group = svgEl('g', { class: 'ameoro-net__thread-group' }, threadsG);
      const path = svgEl('path', { d, class: 'ameoro-net__thread' }, group);
      path.dataset.countries = `${e.a.country} ${e.b.country}`;
      return path;
    });

    /* Order journey: one parcel travels the main route while the steps below the map light up in order. */
    const setStep = (current) => steps.forEach((step, i) => {
      step.classList.toggle('is-done', i < current);
      step.classList.toggle('is-current', i === current);
    });

    function runJourney(path) {
      const run = (journeyRun += 1);
      journeyPath = path;
      parcel?.remove();
      parcel = null;
      if (!path || reduceMotion.matches) {
        setStep(steps.length);
        return;
      }
      if (replayBtn) replayBtn.hidden = true;
      setStep(0);
      parcel = svgEl('circle', { r: 1, class: 'ameoro-net__parcel' }, beadsG);
      const length = path.getTotalLength();
      const thresholds = [0, 0.1, 0.3]; // check, dispatch, transit; delivered at arrival
      const start = performance.now() + 900;
      const duration = 3800;
      const tick = (now) => {
        if (run !== journeyRun) return;
        const k = Math.max(0, Math.min(1, (now - start) / duration));
        const e = ease(k);
        const pt = path.getPointAtLength(e * length);
        parcel.setAttribute('transform', `translate(${pt.x.toFixed(1)} ${pt.y.toFixed(1)}) scale(${(unit * 4.5).toFixed(3)})`);
        setStep(k >= 1 ? 3 : thresholds.filter((t) => e >= t).length - 1);
        if (k < 1) {
          requestAnimationFrame(tick);
          return;
        }
        setTimeout(() => {
          if (run !== journeyRun) return;
          setStep(4);
          if (replayBtn) replayBtn.hidden = false;
        }, 1100);
      };
      requestAnimationFrame(tick);
    }

    replayBtn?.addEventListener('click', () => runJourney(journeyPath));

    /* Destination routes */
    function setDestination(code, name, animateIn) {
      routesG.textContent = '';
      destG.textContent = '';
      for (let i = beads.length - 1; i >= 0; i -= 1) if (beads[i].route) { beads[i].el.remove(); beads.splice(i, 1); }
      land.querySelectorAll('.is-dest').forEach((p) => p.classList.remove('is-dest'));
      root.classList.toggle('is-dest-us', code === 'US');

      if (estimate) {
        estimate.textContent = (FAST.has(code) ? estimate.dataset.fast : estimate.dataset.world).replace('__COUNTRY__', name);
      }
      if (delivered) delivered.textContent = FAST.has(code) ? delivered.dataset.fast : delivered.dataset.world;
      const point = CENTROIDS[code];
      if (!point) {
        runJourney(null);
        return;
      }
      land.querySelector(`[data-iso="${code}"]`)?.classList.add('is-dest');

      let [x, y] = project(point);
      const outside = x < 0 || x > W || y < 0 || y > H;
      if (outside) {
        const cx = W / 2;
        const cy = H / 2;
        const dx = x - cx;
        const dy = y - cy;
        const tx = dx ? ((dx > 0 ? W - 60 : 60) - cx) / dx : Infinity;
        const ty = dy ? ((dy > 0 ? H - 40 : 40) - cy) / dy : Infinity;
        const t = Math.min(tx, ty);
        x = cx + dx * t;
        y = cy + dy * t;
      }
      const dest = { x: Math.round(x), y: Math.round(y) };

      const byDistance = pins.slice().sort((a, b) => Math.hypot(a.x - x, a.y - y) - Math.hypot(b.x - x, b.y - y));
      const origins = [byDistance[0], byDistance.find((p) => p.country !== byDistance[0].country)].filter(Boolean);
      const routePaths = origins.map((origin, i) => {
        const path = svgEl('path', { d: curve(origin, dest, i ? 0.22 : -0.22), class: 'ameoro-net__route' }, routesG);
        stitch(path, animateIn ? 150 * i : 0, 900);
        addBead(path, true);
        return path;
      });
      runJourney(routePaths[0]);

      const marker = svgEl('g', { class: 'ameoro-net__dest-marker', transform: `translate(${dest.x} ${dest.y})` }, destG);
      const body = svgEl('g', { class: 'ameoro-net__dest-body' }, marker);
      svgEl('circle', { r: 11, class: 'ameoro-net__dest-ring' }, body);
      svgEl('circle', { r: 3.5, class: 'ameoro-net__dest-dot' }, body);
      const anchorEnd = dest.x > W * 0.72;
      const label = svgEl('text', { x: anchorEnd ? -16 : 16, y: 4.5, class: 'ameoro-net__dest-label', 'text-anchor': anchorEnd ? 'end' : 'start' }, body);
      label.textContent = outside ? root.dataset.toCountry.replace('__COUNTRY__', name) : name;
      if (!reduceMotion.matches) {
        body.animate([{ opacity: 0, transform: `scale(${unit * 0.4})` }, { opacity: 1, transform: `scale(${unit})` }], { duration: 500, easing: 'cubic-bezier(.2,.8,.2,1)' });
      }
    }

    /* Country focus + zoom */
    function zoomTo(target) {
      const from = viewBox.slice();
      const start = performance.now();
      const duration = reduceMotion.matches ? 0 : 800;
      const step = (now) => {
        const k = duration ? Math.min(1, (now - start) / duration) : 1;
        const e = ease(k);
        viewBox = from.map((v, i) => v + (target[i] - v) * e);
        svg.setAttribute('viewBox', viewBox.map((v) => v.toFixed(2)).join(' '));
        setUnit();
        if (k < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }

    function boxFor(code) {
      const pts = pins.filter((p) => p.country === code);
      if (!pts.length) return [0, 0, W, H];
      const xs = pts.map((p) => p.x);
      const ys = pts.map((p) => p.y);
      const pad = 110;
      let w = Math.max(Math.max(...xs) - Math.min(...xs) + pad * 2, 300);
      let h = Math.max(Math.max(...ys) - Math.min(...ys) + pad * 2, 280);
      if (w / h > W / H) h = (w * H) / W; else w = (h * W) / H;
      const cx = (Math.max(...xs) + Math.min(...xs)) / 2;
      const cy = (Math.max(...ys) + Math.min(...ys)) / 2;
      return [Math.min(Math.max(cx - w / 2, 0), W - w), Math.min(Math.max(cy - h / 2, 0), H - h), w, h];
    }

    function focusCountry(code) {
      active = code && code !== active ? code : null;
      root.classList.toggle('is-focused', !!active);
      chips.forEach((c) => c.setAttribute('aria-pressed', String(c.dataset.netChip === active)));
      panels.forEach((p) => { p.hidden = p.dataset.netPanel !== active; });
      pins.forEach((p) => p.g.classList.toggle('is-active', p.country === active));
      root.querySelectorAll('[data-net-inset] [data-net-pin]').forEach((g) => g.classList.toggle('is-active', g.dataset.country === active));
      threadPaths.forEach((p) => p.classList.toggle('is-active', !!active && p.dataset.countries.includes(active)));
      land.querySelectorAll('.is-active').forEach((p) => p.classList.remove('is-active'));
      if (active) land.querySelector(`[data-iso="${active}"]`)?.classList.add('is-active');
      if (resetBtn) resetBtn.hidden = !active;
      const hasMainPins = pins.some((p) => p.country === active);
      zoomTo(active && hasMainPins ? boxFor(active) : [0, 0, W, H]);
    }

    chips.forEach((chip) => chip.addEventListener('click', () => focusCountry(chip.dataset.netChip)));
    pins.forEach((p) => p.g.addEventListener('click', () => focusCountry(p.country)));
    resetBtn?.addEventListener('click', () => { focusCountry(null); chips[0]?.focus(); });
    root.addEventListener('keydown', (e) => { if (e.key === 'Escape' && active) focusCountry(null); });
    select?.addEventListener('change', () => setDestination(select.value, select.selectedOptions[0].text, true));

    /* Ambient beads */
    function frame(now) {
      if (!running) return;
      const dt = Math.min((now - (lastFrame || now)) / 1000, 0.1);
      lastFrame = now;
      const size = unit * 2.6;
      for (const b of beads) {
        b.t = (b.t + b.speed * dt) % b.length;
        const pt = b.path.getPointAtLength(b.t);
        b.el.setAttribute('transform', `translate(${pt.x.toFixed(1)} ${pt.y.toFixed(1)}) scale(${(b.route ? size * 1.15 : size).toFixed(3)})`);
      }
      requestAnimationFrame(frame);
    }

    function updateRunning() {
      const should = inView && !paused && !document.hidden && !reduceMotion.matches;
      root.classList.toggle('is-paused', !should);
      if (should && !running) { running = true; lastFrame = 0; requestAnimationFrame(frame); }
      if (!should) running = false;
    }

    pauseBtn?.addEventListener('click', () => {
      paused = !paused;
      pauseBtn.setAttribute('aria-pressed', String(paused));
      pauseBtn.textContent = paused ? pauseBtn.dataset.play : pauseBtn.dataset.pause;
      updateRunning();
    });
    document.addEventListener('visibilitychange', updateRunning);

    /* Entrance: fabric, pins, thread, destination, then beads */
    function entrance() {
      const motion = !reduceMotion.matches;
      if (motion) {
        land.animate([{ clipPath: 'inset(0 100% 0 0)' }, { clipPath: 'inset(0 0 0 0)' }], { duration: 1500, easing: 'cubic-bezier(.3,0,.2,1)', fill: 'backwards' });
        pins.slice().sort((a, b) => a.x - b.x).forEach((p, i) => {
          const delay = 600 + i * 70;
          p.g.querySelector('.ameoro-net__pin-drop').animate(
            [{ opacity: 0, transform: 'translateY(-18px)' }, { opacity: 1, transform: 'translateY(0)' }],
            { duration: 520, delay, easing: 'cubic-bezier(.2,.9,.25,1.2)', fill: 'backwards' }
          );
          p.g.querySelector('.ameoro-net__pin-ring').animate(
            [{ opacity: 0.9, transform: 'scale(1)' }, { opacity: 0, transform: 'scale(3)' }],
            { duration: 900, delay: delay + 420, easing: 'ease-out' }
          );
        });
        threadPaths.forEach((path, i) => stitch(path, 900 + i * 90, 650));
      }
      const destDelay = motion ? 1100 + threadPaths.length * 90 : 0;
      setTimeout(() => {
        if (select && select.value) setDestination(select.value, select.selectedOptions[0].text, true);
        threadPaths.forEach((path) => addBead(path, false));
        inView = true;
        updateRunning();
      }, destDelay);
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) { inView = false; updateRunning(); return; }
        if (!root.dataset.entered) { root.dataset.entered = 'true'; entrance(); return; }
        inView = true;
        updateRunning();
      });
    }, { threshold: 0.3 });
    io.observe(svg);
  }

  /* Chat channel: open Shopify Inbox (shown on the contact page only); if it is not loaded, the link falls back to the form. */
  function initChat(root) {
    root.querySelectorAll('[data-contact-chat]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const trigger = document.querySelector('shopify-chat, inbox-online-store-chat')?.shadowRoot?.querySelector('button');
        if (!trigger) return;
        event.preventDefault();
        trigger.click();
      });
    });
  }

  function init(scope) {
    scope.querySelectorAll('[data-ameoro-contact]').forEach((root) => {
      initStatus(root);
      initChat(root);
      initNetwork(root);
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
